export enum TelemetryEvent {
  SUBSCRIBERS_LINK_CLICKED = 'Subscribers link clicked - [Left navigation]',
  NEW_DASHBOARD_OPT_OUT = 'New dashboard opt-out',
  NEW_DASHBOARD_OPT_IN = 'New dashboard opt-in',
  CREATE_ORGANIZATION_FORM_SUBMITTED = 'Create Organization Form Submitted',
  USE_CASE_SELECTED = 'Use Case Selected',
  USE_CASE_SKIPPED = 'Use Case Skipped',
  RESOURCE_CLICKED = 'Resource clicked - [Welcome]',
  WORKFLOWS_PAGE_VISIT = 'Workflows page visit',
  CONTEXTS_PAGE_VISIT = 'Contexts page visit',
  WELCOME_PAGE_VIEWED = 'Welcome page viewed - [Welcome]',
  WELCOME_STEP_CLICKED = 'Welcome step clicked - [Welcome]',
  WELCOME_STEP_COMPLETED = 'Welcome step completed - [Welcome]',
  WELCOME_MENU_HIDDEN = 'Welcome menu hidden - [Welcome]',
  INBOX_NOTIFICATION_SENT = 'Inbox notification sent - [Onboarding]',
  INBOX_CUSTOMIZATION_CHANGED = 'Inbox customization changed - [Onboarding]',
  INBOX_NEXT_STEP_CLICKED = 'Inbox next step clicked - [Onboarding]',
  INBOX_IMPLEMENTATION_CLICKED = 'Implement Inbox clicked - [Onboarding]',
  INBOX_PREVIEW_STYLE_CHANGED = 'Inbox preview style changed - [Onboarding]',
  INBOX_FRAMEWORK_SELECTED = 'Inbox framework selected - [Onboarding]',
  AI_PROMPT_COPIED = 'AI prompt copied - [Onboarding]',
  SKIP_ONBOARDING_CLICKED = 'Skip onboarding clicked - [Onboarding]',
  ONBOARDING_COMPLETED = 'Onboarding completed - [Onboarding]',
  USECASE_SELECT_PAGE_VIEWED = 'Use case select page viewed - [Onboarding]',
  INBOX_USECASE_PAGE_VIEWED = 'Inbox use case page viewed - [Onboarding]',
  INBOX_EMBED_PAGE_VIEWED = 'Inbox embed page viewed - [Onboarding]',
  INBOX_EMBED_SUCCESS_PAGE_VIEWED = 'Inbox embed success page viewed - [Onboarding]',
  BILLING_PAGE_VIEWED = 'Billing page viewed - [Billing]',
  BILLING_INTERVAL_CHANGED = 'Billing interval changed - [Billing]',
  BILLING_PAYMENT_SUCCESS = 'Payment successful - [Billing]',
  BILLING_PAYMENT_CANCELED = 'Payment canceled - [Billing]',
  BILLING_UPGRADE_INITIATED = 'Upgrade initiated - [Billing]',
  BILLING_UPGRADE_ERROR = 'Upgrade error - [Billing]',
  BILLING_PORTAL_ACCESSED = 'Portal accessed - [Billing]',
  BILLING_PORTAL_ERROR = 'Portal access error - [Billing]',
  BILLING_CONTACT_SALES_CLICKED = 'Contact sales clicked - [Billing]',
  BILLING_CONTACT_SALES_MODAL_CLOSED = 'Contact sales modal closed - [Billing]',
  USAGE_CARD_CLICKED = 'Usage card clicked - [Side Navigation]',
  WORKFLOW_PREFERENCES_OVERRIDE_USED = 'Workflow preferences override used',
  EXPORT_TO_CODE_BANNER_REACTION = 'Export to Code banner reaction - [Promotional]',
  EXTERNAL_LINK_CLICKED = 'External link clicked',
  CHANGELOG_ITEM_CLICKED = 'Changelog item clicked',
  CHANGELOG_ITEM_DISMISSED = 'Changelog item dismissed',
  SHARE_FEEDBACK_LINK_CLICKED = 'Share feedback link clicked',
  VARIABLE_POPOVER_OPENED = 'Variable popover opened - [Variable Editor]',
  VARIABLE_POPOVER_APPLIED = 'Variable popover applied - [Variable Editor]',
  TEMPLATE_MODAL_OPENED = 'Template Modal Opened - [Template Store]',
  TEMPLATE_CATEGORY_SELECTED = 'Template Category Selected - [Template Store]',
  CREATE_WORKFLOW_FROM_TEMPLATE = 'Create Workflow From Template - [Template Store]',
  CREATE_WORKFLOW_CLICK = 'Create Workflow Click',
  GENERATE_WORKFLOW_CLICK = 'Generate Workflow Click',
  TEMPLATE_WORKFLOW_CLICK = 'Template Workflow Click',
  ENVIRONMENTS_PAGE_VIEWED = 'Environments Page Viewed',
  CREATE_ENVIRONMENT_CLICK = 'Create Environment Click',
  UPGRADE_TO_TEAM_TIER_CLICK = 'Upgrade to Team Tier Click',
  INVITE_TEAM_CLICKED = 'Invite team clicked - [Onboarding]',
  WORKFLOW_CHECKLIST_OPENED = 'Workflow checklist opened - [Workflow Editor]',
  WORKFLOW_CHECKLIST_COMPLETED = 'Workflow checklist completed - [Workflow Editor]',
  WORKFLOW_CHECKLIST_STEP_CLICKED = 'Workflow checklist step clicked - [Workflow Editor]',
  WORKFLOW_INSTRUCTIONS_OPENED = 'Workflow instructions opened - [Workflow Editor]',
  SUBSCRIBERS_PAGE_VISIT = 'Subscribers page visit',
  ANALYTICS_PAGE_VISIT = 'Analytics page visit',
  SUBSCRIBER_CREATED = 'Subscriber created',
  SUBSCRIBER_EDITED = 'Subscriber edited',
  SUBSCRIBER_DELETED = 'Subscriber deleted',
  SUBSCRIBER_PREFERENCES_UPDATED = 'Subscriber preferences updated',
  SIGN_UP_PAGE_VIEWED = 'Signup page viewed',
  SIGN_IN_PAGE_VIEWED = 'Signin page viewed',
  STEP_CONDITIONS_ADDED = 'Step conditions added',
  STEP_CONDITIONS_UPDATED = 'Step conditions updated',
  EMAIL_BLOCK_ADDED = 'Email block added',
  DIGEST_BLOCK_ADDED = 'Digest block added',
  INBOX_DATA_OBJECT_PROPERTY_ADDED = 'Inbox data object property added',
  CARD_BLOCK_ADDED = 'Card block added',
  TOPICS_PAGE_VISIT = 'Topics Page Visit',
  DIGEST_VARIABLE_SELECTED = 'Digest variable selected',
  LAYOUTS_PAGE_VISIT = 'Layouts page visit',
  LAYOUTS_CREATE_CLICKED = 'Layouts create clicked',
  LAYOUT_CREATED = 'Layout created',
  LAYOUT_DUPLICATED = 'Layout duplicated',
  REQUEST_LOGS_PAGE_VISIT = 'Request logs page visit',
  REQUEST_LOG_ENTRY_CLICKED = 'Request log entry clicked',
  COMMAND_PALETTE_OPENED = 'Command palette opened',
  COMMAND_PALETTE_COMMAND_SELECTED = 'Command palette command selected',
  INBOX_WORKFLOW_UPDATE_FAILED = 'Inbox workflow update failed - [Onboarding]',
  SUPPORT_DRAWER_ASK_AI_CLICKED = 'Support drawer ask AI clicked',
  SUPPORT_DRAWER_OPENED = 'Support drawer opened - [Support]',
  SUPPORT_DRAWER_SUGGESTION_CLICKED = 'Support drawer suggestion clicked - [Support]',
  SUPPORT_DRAWER_DOCUMENTATION_CLICKED = 'Support drawer documentation clicked - [Support]',
  SUPPORT_DRAWER_CHANGELOG_CLICKED = 'Support drawer changelog clicked - [Support]',
  SUPPORT_DRAWER_ROADMAP_CLICKED = 'Support drawer roadmap clicked - [Support]',
  SUPPORT_DRAWER_CHAT_CLICKED = 'Support drawer chat clicked - [Support]',
  SUPPORT_DRAWER_BOOK_DEMO_CLICKED = 'Support drawer book demo clicked - [Support]',
  SUPPORT_DRAWER_DOCS_BACK_CLICKED = 'Support drawer docs back clicked - [Support]',
  SUPPORT_DRAWER_DOCS_EXTERNAL_CLICKED = 'Support drawer docs external link clicked - [Support]',

  COPILOT_MESSAGE_SENT = 'Copilot message sent - [AI Copilot]',
  COPILOT_GENERATION_COMPLETED = 'Copilot generation completed - [AI Copilot]',
  COPILOT_GENERATION_ERROR = 'Copilot generation error - [AI Copilot]',
  COPILOT_GENERATION_STOPPED = 'Copilot generation stopped - [AI Copilot]',
  COPILOT_CHANGES_KEPT = 'Copilot changes kept - [AI Copilot]',
  COPILOT_CHANGES_REVERTED = 'Copilot changes reverted - [AI Copilot]',
  COPILOT_CHANGES_DISCARDED = 'Copilot changes discarded - [AI Copilot]',
  COPILOT_TRY_AGAIN = 'Copilot try again - [AI Copilot]',
  COPILOT_CHAT_CREATED = 'Copilot chat created - [AI Copilot]',
  COPILOT_CHAT_RESUMED = 'Copilot chat resumed - [AI Copilot]',
  COPILOT_WORKFLOW_GENERATED = 'Copilot workflow generated - [AI Copilot]',
  COPILOT_GUIDED_SUBMIT = 'Copilot guided submit - [AI Copilot]',
  COPILOT_SUGGESTION_CLICKED = 'Copilot suggestion clicked - [AI Copilot]',
  COPILOT_TAB_SWITCHED = 'Copilot tab switched - [AI Copilot]',

  STEP_RESOLVER_CUSTOM_CODE_CLICKED = 'Custom code clicked - [Workflow Editor]',
}
